import React, {useEffect, useState} from 'react';
import './menu.css';

export default function Menu(){
const [sideBar, setSideBar] = useState(false);
 
useEffect(() => {
  window.addEventListener('scroll', ()=>{
    if (window.scrollY > 30) {
      setSideBar(true)
    }else {
      setSideBar(false)
    }
  })  
})

  return (
    <>
      <div id="top">
        <nav className="horizontal">
          <ul className="topMenu">
            <li><a href="#about">About</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
        <div className="signature"></div>
      </div>
      <div>
      <nav className={sideBar ? "vertical in" : "vertical out"}>
        <ul className="sideMenu">
          <li><a href="#top">About</a></li>
          <li><a href="#portfolio">Portfolio</a></li>
          <li><a href="#contact">Contact</a></li>
          <li className="signatureSm"></li>
        </ul>
      </nav>
      </div>
    </>
  )
}